import axios from "axios";
import { endpoint } from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export const getLatestNews = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/news/latest`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const newsLetterSubscription = (payload) => {
  clearCookie()
  return axios
    .post(`${endpoint}/api/subscription`, payload, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export const getpartnershipData = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/partnership`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      return err;
    });
}
